import React from 'react';
import { Route } from 'react-router';

import App from './containers/App';
import Menu from './containers/Menu';
import Section from './containers/Section';

export default (
  <Route>
    <Route
      path="/:lang"
      component={App}
    >
      <Route
        path="*"
        components={{ menu: Menu, section: Section }}
      />
    </Route>
  </Route>
);



// WEBPACK FOOTER //
// ./common/routes.js